import React from 'react'

export function ChatKitChatIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_2386_227)">
        <path
          d="M20 0C21.1046 0 22 0.895431 22 2V25.5L14.6113 22H2C0.895431 22 3.22133e-08 21.1046 0 20V2C0 0.895431 0.895431 3.22128e-08 2 0H20Z"
          fill="white"
        />
        <path
          d="M19.0001 15.0002C19.2088 15.3577 19.0883 15.8175 18.7276 16.0206C15.7195 17.7136 13.2476 18.6278 10.7852 18.6328C8.32291 18.6378 5.97982 17.7346 3.22656 16.0312C2.87441 15.8134 2.77498 15.3481 2.9998 15.0003C3.22478 14.6523 3.6894 14.554 4.04202 14.7717C6.66993 16.3937 8.7236 17.137 10.7822 17.1328C12.8628 17.1285 15.0594 16.3617 17.971 14.7258C18.3321 14.5229 18.7913 14.6425 19.0001 15.0002Z"
          fill="rgb(var(--text-primary))"
        />
      </g>
      <defs>
        <clipPath id="clip0_2386_227">
          <rect width="22" height="25.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
